module.exports = __webpack_public_path__ + "img/xcover.affa80f8.svg";